var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"country-list"},_vm._l((_vm.availableCountries),function(countryName,countryCode){return _c('button',{key:countryCode,staticClass:"country-list_item",class:[
      'country-list_item__' + countryCode.toLowerCase(),
      _vm.currentCountry === countryCode && 'country-list_item__current'
    ],on:{"click":function($event){return _vm.changeCountry(countryCode)}}},[_vm._v("\n    "+_vm._s(_vm.$t(countryName[0]))+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }